import { render, staticRenderFns } from "./x-list-page.vue?vue&type=template&id=27a2122a"
import script from "./x-list-page.vue?vue&type=script&lang=js"
export * from "./x-list-page.vue?vue&type=script&lang=js"
import style0 from "./x-list-page.vue?vue&type=style&index=0&id=27a2122a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports